import React, { Fragment, Component, createRef, ChangeEvent } from 'react'
import TextInput from 'tfs.form-text-input'

import NotificationInterface from '../../interfaces/client/Notification'
import ClientInfantPassengerInterface from '../../interfaces/client/InfantPassenger'

import { frontEndDateFormat } from '../../config/dates'

import getNotificationLabelFromCode from '../../utils/notifications/getNotificationLabelFromCode'

import GenderSelect from '../../containers/GenderSelect'

import styles from './NewBookingFormInfant.module.scss'

interface NewBookingFormInfantRowState {
  showDateInputError: boolean
}

interface NewBookingFormInfantRowProps {
  onChange: Function
  infantDateOfBirthValidator: Function
  validateInfantDateOfBirth: Function

  passengerId: string
  rowId: number

  showTravelClass: boolean
  isDisabled: boolean

  firstNameError?: NotificationInterface
  lastNameError?: NotificationInterface
  dateOfBirthError?: NotificationInterface
  readonly?: string
  uploadedInfant?: ClientInfantPassengerInterface
}

export default class NewBookingFormInfantRow extends Component<
  NewBookingFormInfantRowProps,
  NewBookingFormInfantRowState
> {
  firstNameRef = createRef()
  lastNameRef = createRef()
  dateOfBirthRef = createRef()
  genderRef = createRef()

  private readonly _handleDateInputChange = (
    event: ChangeEvent<HTMLInputElement>
  ) => {
    this.props.validateInfantDateOfBirth(
      event.target,
      this.props.passengerId,
      this.props.infantDateOfBirthValidator,
      this.props.dateOfBirthError
    )
  }

  render() {
    const {
      passengerId,
      showTravelClass,
      readonly,
      isDisabled,
      firstNameError,
      lastNameError,
      dateOfBirthError,
      onChange,
      uploadedInfant,
      rowId,
    } = this.props

    return (
      <Fragment>
        <span></span>
        <span></span>
        <span></span>

        <span className={styles['input-default']}>
          <TextInput
            elementRef={this.firstNameRef}
            name={`${passengerId}-infant-first-name`}
            data-element={`${rowId}-infant-first-name`}
            required={true}
            readOnly={readonly}
            disabled={isDisabled}
            onChange={() => onChange(firstNameError)}
            error={getNotificationLabelFromCode(firstNameError)}
            defaultValue={uploadedInfant && uploadedInfant.firstName}
          />
        </span>

        <span
          className={styles['input-last-name']}
          data-element={`${rowId}-infant-last-name-wrapper`}
        >
          <TextInput
            elementRef={this.lastNameRef}
            name={`${passengerId}-infant-last-name`}
            data-element={`${rowId}-infant-last-name`}
            required={true}
            readOnly={readonly}
            disabled={isDisabled}
            onChange={() => onChange(lastNameError)}
            error={getNotificationLabelFromCode(lastNameError)}
            defaultValue={uploadedInfant && uploadedInfant.lastName}
          />
        </span>

        <span
          className={styles['input-date-of-birth']}
          data-element={`${rowId}-infant-date-of-birth-wrapper`}
        >
          <TextInput
            elementRef={this.dateOfBirthRef}
            name={`${passengerId}-infant-date-of-birth`}
            data-element={`${rowId}-infant-date-of-birth`}
            required={true}
            placeholder={frontEndDateFormat}
            pattern="\d{2}-\d{2}-\d{4}"
            onChange={this._handleDateInputChange}
            readOnly={readonly}
            disabled={isDisabled}
            error={getNotificationLabelFromCode(dateOfBirthError)}
            defaultValue={uploadedInfant && uploadedInfant.dateOfBirth}
          />
        </span>

        <span className={styles['input-select']}>
          <GenderSelect
            refName={`${rowId}-infant-gender`}
            inputName={`${passengerId}-infant-gender`}
            isRequired={true}
            isDisabled={isDisabled || Boolean(readonly)}
            defaultValue={(uploadedInfant && uploadedInfant.gender) || ''}
          />
        </span>

        {showTravelClass && <span></span>}
        <span></span>
        <span></span>
      </Fragment>
    )
  }
}
